export const MAX_LEN_TEST_TITLE = 140;
export const MAX_LEN_TEST_SUBTITLE = 270;
